import { render, staticRenderFns } from "./SubscribeTestimonialsItem.vue?vue&type=template&id=d6990b92&scoped=true&"
import script from "./SubscribeTestimonialsItem.vue?vue&type=script&lang=js&"
export * from "./SubscribeTestimonialsItem.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeTestimonialsItem.vue?vue&type=style&index=0&id=d6990b92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6990b92",
  null
  
)

export default component.exports